module.exports = __webpack_public_path__ + "static/media/powerfulbenchmarker.35d1ca7a.jpg";